<section class="mainTopBanner section-pd">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="topBannerWrapper">
                    <div class="top-banner-left">
                        <h1 class="trinka-sub-title">瀏覽器擴充功能</h1>
                        <h2>Trinka 瀏覽器擴充工具</h2>
                        <p>Trinka 瀏覽器擴充功能可在您常用的網站上即時提升寫作品質，無論在哪裡撰寫，都能自信表達！</p>
                        <div id="safariBrowser" *ngIf="browser === 'safari'">
                            <button title="Coming soon for Safari">
                                <img src="/assets/images/icons/NewSafari_icon.svg" alt="safari">
                                Coming soon
                            </button>
                            <div class="downloadForSafari">
                                <h6>Download for:</h6>
                                <ul>
                                    <li>
                                        <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank" title="Download for Chrome">
                                            <img src="/assets/images/NewChromeFicon.svg" alt="chrome">
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" title="Download for Firefox">
                                            <img src="/assets/images/NewFirefoxFicon.svg" alt="firefox">
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" title="Download for Edge">
                                            <img src="/assets/images/EdgeWhite_BGAndOutline.svg" alt="edge">
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div id="BrowserGoogleChromeSection" *ngIf="browser === 'chrome'">
                            <div class="btn-group">
                                <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"
                                    class="filled-btn" id="BrowserChromeButton">
                                    <b>
                                        <img src="/assets/images/NewChromeFicon.svg" alt="Grammar checker for Chrome">
                                    </b>
                                    <i>安裝 Chrome 版</i>
                                </a>
                            </div>
                            <br />
                            <div class="commingSoonSeciton">
                                <p class="FirefoxAvalibale">
                                    <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank">
                                        <img style="width: 32px;" src="/assets/images/NewFirefoxFicon.svg" alt="Grammar checker for Firefox"> Download for Firefox
                                    </a>
                                </p>
                                <p class="SafariComingSoon EdgeBrowserPlugin">
                                    <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank">
                                        <img style="width: 30px;" src="/assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Chrome"> Download for Edge
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div id="BrowserFirefoxSection" *ngIf="browser === 'firefox'">
                            <div class="btn-group">
                                <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank" class="filled-btn" id="BrowserFireFoxButton">
                                    <b>
                                        <img src="/assets/images/NewFirefoxFicon.svg" alt="Grammar checker for Firefox">
                                    </b>
                                    <i>下載 Firefox 版</i>
                                </a>
                            </div>
                            <br />
                            <div class="commingSoonSeciton">
                                <p class="FirefoxAvalibale">
                                    <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank">
                                        <img style="width: 32px;" src="/assets/images/NewChromeFicon.svg" alt="Grammar checker for Firefox"> Download for Chrome
                                    </a>
                                </p>
                                <p class="SafariComingSoon EdgeBrowserPlugin">
                                    <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank">
                                        <img style="width: 30px;" src="/assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Chrome"> Download for Edge
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div id="BrowserEdgeBrowserSection" *ngIf="browser === 'edge'">
                            <div class="btn-group">

                                <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank"
                                    class="filled-btn" id="BrowserEdgeButton">
                                    <b>
                                        <img src="/assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Firefox">
                                    </b>
                                    <i>下載 Edge 版</i>
                                </a>
                            </div>
                            <br />
                            <div class="commingSoonSeciton">
                                <p class="FirefoxAvalibale">
                                    <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank">
                                        <img style="width: 32px;" src="/assets/images/NewChromeFicon.svg" alt="Grammar checker for Firefox"> Download for Chrome
                                    </a>
                                </p>
                                <p class="SafariComingSoon EdgeBrowserPlugin">
                                    <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank">
                                        <img style="width: 30px;" src="/assets/images/NewFirefoxFicon.svg" alt="Grammar checker for Chrome"> Download for Firefox
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="top-banner-right">
                        <img src="/assets/images/browser-plugin/BrowserPlugin_banner.webp" width="2501" height="2501" class="img-fluid md50" alt="plugin" priority />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd-sm bg-light">
    <app-trusted-global-leaders [sliderData]="globalSliderData" trustedPartnerTitle="深受全球領導品牌肯定"></app-trusted-global-leaders>
</section>

<section class="section-pd list-wrapper-style-2">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-12 col-lg-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>Trinka 瀏覽器擴充功能特色</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinka 可作為 Chrome、Firefox、Edge 等主流瀏覽器的擴充功能使用，隨時隨地幫助您提升英文寫作能力。即時提供高級文法修正與建議，所有修改都會自動檢查，不再漏看錯誤。</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards bt-none">
                    <img src="/assets/images/realTimeEditing_icon.svg" width="40" height="40" alt="icon">
                    <h3>即時修正</h3>
                    <p>無需等待，Trinka 在您輸入時即時提供文法建議與修正。
                    </p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="/assets/images/AddtoDictionary.svg" width="40" height="40" alt="icon">
                    <h3>自訂詞典</h3>
                    <p>將常用詞加入「個人詞典」，未來 Trinka 將不會標記為拼字錯誤。</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="list-wrapper-content-2 list-style-cards">
                    <img src="/assets/images/DataSecurityIcon.svg" width="40" height="40" alt="icon">
                    <h3>資料安全保障</h3>
                    <p>所有輸入內容皆透過安全傳輸並即時分析，絕不儲存您的資料。</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section-pd pb-0 pt-0">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-lg-12 col-md-12">
                <div class="trinka-title mb-0 text-center">
                    <h2>Trinka 瀏覽器擴充功能：隨你所寫，隨時支援</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-pd list-wrapper-style-2 ">
        <div class="trinka_container container">
            <div class="row align-items-center flex-row-reverse">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2">
                        <h3>Google 文件上的文法校正</h3>
                        <p>想在 Google 文件上更順利地寫出優質內容，輕鬆修正所有文法錯誤嗎？
                        </p>
                        <p>安裝 Trinka 瀏覽器擴充功能，即可在 Google 文件中享有即時的文法與拼字修正，以及語句優化建議。</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image features-img">
                        <img src="/assets/images/browser-plugin/google-doc-ss.webp" width="729" height="387" alt="google doc" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-pd list-wrapper-style-2 pt-0">
        <div class="trinka_container container">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2 pr-80">
                        <h3>在 Authorea 上寫得更好</h3>
                        <p>你使用 Authorea 撰寫學術或專業內容嗎？那麼，一套即時文法修正工具絕對不可或缺！</p>
                        <p>安裝 Trinka 瀏覽器擴充功能，立即改善句子錯誤，讓你在 Authorea 上輕鬆寫出高品質內容。</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image features-img">
                        <img src="/assets/images/browser-plugin/authorea-ss.webp" width="729" height="387" alt="authorea" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-pd list-wrapper-style-2 pt-0">
        <div class="trinka_container container">
            <div class="row align-items-center flex-row-reverse">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2">
                        <h3>修正 Evernote 上的寫作內容</h3>
                        <p>使用 Evernote 紀錄或寫作時，也能透過 Trinka 提升內容品質。</p>
                        <p>Trinka 搭載 AI 技術，能即時修正文法錯誤並強化語言表達。擴充功能完全相容 Evernote，簡單安裝後即可開始使用，讓校稿變得毫不費力。</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image features-img">
                        <img src="/assets/images/browser-plugin/evernote-ss.webp" width="729" height="387" alt="evernote" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-pd list-wrapper-style-2 pt-0">
        <div class="trinka_container container">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <div class="list-wrapper-content-2 pr-80">
                        <h3>在 Medium 寫出更吸引人的文章</h3>
                        <p>常在 Medium 發表文章嗎？別錯過 Trinka 免費瀏覽器擴充功能所提供的強大寫作協助！</p>
                        <p>Trinka 能自動修正文法、語氣、標點與句構，全面提升文章品質，讓你的內容更具說服力、吸引更多讀者。</p>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="list-wrapper-image features-img">
                        <img src="/assets/images/browser-plugin/medium-ss.webp" width="729" height="387" alt="medium" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="ListLiners hideBrowserPlugin">
    <app-trinka-in-other-apps></app-trinka-in-other-apps>
</section>